type RiskBaseGlobalType = {
  reduxPersistError: null | Error;
};

export const RiskBaseGlobal: RiskBaseGlobalType = {
  reduxPersistError: null,
};
